import React from 'react';
import { sliderSettings } from '../../utils/common.js';
import {Swiper,SwiperSlide,useSwiper} from 'swiper/react'
import "swiper/css";
import "./Recedencies.css";
import data from "../../utils/slider.json";
// import { Link } from "react-router-dom";

const Recedencies = ({refProp}) => {
  return (
    <>
     <section ref={refProp}> 
    <section className='r-wrapper'>
    <div className="r-container">
        <div className="r-head">
        <span>Best Choices </span>
        <span> Popular Residencies</span>

    </div>
    <Swiper {...sliderSettings}>
      <SliderButtons />  

      {
        data.map((card,i)=>(
          <SwiperSlide key={i}>
            <div className="r-card">
              <img src={card.image} alt="img" />
              <span className='secondaryText r-price'>
              <span style={{color:'orange'}}>₹</span>
              <span>{ (card.price)}</span>
              </span>
              <span className="primaryText">{" "+card.name}</span>
              <span className="secondaryText">{" "+card.detail}</span>

            </div>
          </SwiperSlide>
        ))

      }
    </Swiper>
   
    </div>

    </section>
    </section>

    </>
   
  );
};

export default Recedencies

const SliderButtons=()=>{
  const swiper= useSwiper();
  return(
    <div className="r-button">
      <button onClick={()=>swiper.slidePrev()}>&lt;</button>

      <button onClick={()=>swiper.slideNext()}>&gt;</button>

    </div>
    

  )


}